import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { RatioTagComponent } from '@app/shared/components/ratio-tag/ratio-tag.component';
import { AdvancedFilterModule } from '@app/shared/modules/advanced-filter/advanced-filter.module';
import { TranslateModule } from '@ngx-translate/core';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzTableModule } from 'ng-zorro-antd/table';
import { CriterionAdditionSharedModule } from '../../criterion-addition-shared.module';
import { QueuePaginationComponent } from './components/queue-pagination/queue-pagination.component';
import { SuggestionAcceptComponent } from './components/suggestion-accept/suggestion-accept.component';
import { SuggestionDestinationCellComponent } from './components/suggestion-destination-cell/suggestion-destination-cell.component';
import { SuggestionPaginationComponent } from './components/suggestion-pagination/suggestion-pagination.component';
import { SuggestionRuleCellComponent } from './components/suggestion-rule-cell/suggestion-rule-cell.component';
import { SuggestionsSubFilterMenuComponent } from './components/suggestion-sub-filter-menu/suggestion-sub-filter-menu.component';
import { SuggestionTableCellComponent } from './components/suggestion-table-cell/suggestion-table-cell.component';
import { SuggestionsAccountInfoComponent } from './components/suggestions-account-info/suggestions-account-info.component';
import { CampaignLabelComponent } from '@app/shared/components/campaign-adgroup-label/campaign-label.component';
import { AdGroupLabelComponent } from '@app/shared/components/campaign-adgroup-label/ad-group-label.component';

@NgModule({
  imports: [
    TranslateModule,
    SharedModule,
    NzTableModule,
    NzPaginationModule,
    CriterionAdditionSharedModule,
    AdvancedFilterModule,
    RatioTagComponent,
    CampaignLabelComponent,
    AdGroupLabelComponent,
  ],
  declarations: [
    SuggestionAcceptComponent,
    SuggestionTableCellComponent,
    SuggestionRuleCellComponent,
    SuggestionDestinationCellComponent,
    SuggestionPaginationComponent,
    QueuePaginationComponent,
    SuggestionsSubFilterMenuComponent,
    SuggestionsAccountInfoComponent,
  ],
  exports: [
    SuggestionsAccountInfoComponent,
    SuggestionPaginationComponent,
    QueuePaginationComponent,
    SuggestionAcceptComponent,
    SuggestionTableCellComponent,
    SuggestionRuleCellComponent,
    SuggestionDestinationCellComponent,
    SuggestionsSubFilterMenuComponent,
  ],
})
export class CriterionAdditionSuggestionsTableModule {}
